import type { UserReviews } from '@ecg-internal/reviews-dialog-ui';

// oxlint-disable-next-line typescript-eslint(no-redundant-type-constituents)
const getDisplayReviewData = (reviewData: UserReviews | undefined) => {
  const displayReviewData = {
    averageScore: 0,
    numberOfReviews: 0,
    withReviewAttribution: false,
  };

  if (!reviewData) {
    return displayReviewData;
  }

  displayReviewData.averageScore = reviewData.rating ?? 0;
  displayReviewData.numberOfReviews = reviewData.numberOfReviews ?? 0;
  displayReviewData.withReviewAttribution = reviewData.reviewSystem === 'GOOGLE_REVIEWS';

  return displayReviewData;
};

export default getDisplayReviewData;
